﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as api from "~base/Services/API";
import * as accountModel from "./Model";
//-------------------------------------------------------------------------------------
// Constants
//-------------------------------------------------------------------------------------

const uri = "api/account/v1/users/confirm-email";
const method = "POST";

//-------------------------------------------------------------------------------------
// Types
//-------------------------------------------------------------------------------------

interface PostConfirmEmailProps extends api.ApiHookBaseProps<
    accountModel.PostConfirmEmailRequest,
    unknown,
    unknown
> {}

//-------------------------------------------------------------------------------------
// API Hook
//-------------------------------------------------------------------------------------

export function useAccountPostConfirmEmail(
    props: PostConfirmEmailProps
): [boolean, (data: accountModel.PostConfirmEmailRequest) => Promise<unknown>] {
    const apiParams: api.ApiHookProps<
        accountModel.PostConfirmEmailRequest,
        unknown,
        unknown
    > = {
        ...props,
        uri: uri,
        method: method,
        skipResponseParsing: true,
    };

    const [loading, invoker] = api.useApi<
        accountModel.PostConfirmEmailRequest,
        unknown,
        unknown
    >(apiParams);
    return [loading, (data) => invoker(apiParams.uri, data)];
}
